module.exports = __webpack_public_path__ + "static/media/42-2.49c4fbb5.mp3";